import React, { useState, useContext } from 'react'
import { toast } from 'react-toastify';
import { api } from '../api/axios';
import { AuthContext } from '../context/AuthContext';


export default function AdsForm() {
    const { setLoading } = useContext(AuthContext);

    const [adsFormData, setAdsFromData] = useState({
        name: '',
        note: '',
        image: ''
    });

    const handelChangeFormData = (e) => {
        const { name, value } = e.target;
        if (e.target.type === 'file') {
            const file = e.target.files[0]
            setAdsFromData({
                ...adsFormData,
                [name]: file
            })
        } else {
            setAdsFromData({
                ...adsFormData,
                [name]: value
            })
        }
    }

    const handelRegisterNewAds = async (e) => {
        e.preventDefault();
        setLoading(true)
        const formData = new FormData();
        formData.append('name', adsFormData.name);
        formData.append('note', adsFormData.note);
        formData.append('image', adsFormData.image);


        try {
            const respons = await api.post('/ads', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })

            if (respons.status === 201) {
                toast.success("Ads Created Successfully")
                setAdsFromData({
                    name: '',
                    note: '',
                    image: ''
                })
            }
        } catch (error) {
            toast.error("Ads Created Error")
            console.error("Ads Error: ", error);
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 1000)
        }
    }




    return (
        <>
            <form onSubmit={handelRegisterNewAds}>
                <div className="border-b border-gray-900/10 pb-2 mb-2">
                    <h2 className="text-base font-semibold text-gray-900">Updates Information</h2>

                    <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 ms-5">
                        <div className="sm:col-span-3">
                            <label htmlFor="name" className="block text-sm/6 font-medium text-gray-900">
                                Name <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={adsFormData.title}
                                    onChange={handelChangeFormData}
                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="image" className="block text-sm/6 font-medium text-gray-900">
                                File <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    id="image"
                                    name="image"
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    onChange={handelChangeFormData}
                                    className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-6">
                            <label htmlFor="note" className="block text-sm/6 font-medium text-gray-900">
                                Note <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-2">
                                <textarea
                                    id="note"
                                    name="note"
                                    type="text"
                                    value={adsFormData.note}
                                    onChange={handelChangeFormData}
                                    required={true}
                                    className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                ></textarea>
                            </div>
                        </div>

                    </div>
                    <div className="mt-2 flex items-center justify-end gap-x-6">
                        <button
                            type="submit"
                            className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        >
                            Save Ads
                        </button>
                    </div>
                </div>



            </form>
        </>
    )
}
